<template>
    <div>
        <div class="news-banner">
            <img src="../../../assets/images/banner7.png" alt="">
            <!-- <div class="banner_warp">
                <div class="top-text">
                    <p>新闻中心</p>
                    <p>能够及时洞悉公司情况，了解行业发展</p>
                </div>
                <img src="" alt="">
            </div> -->
        </div>
        <!-- 面包屑 -->
        <Breadcrumb separator=">" class="nav_rot">
            <Breadcrumb-item><router-link to="/">首页</router-link></Breadcrumb-item>
            <Breadcrumb-item><router-link to="/news">新闻中心</router-link></Breadcrumb-item>
            <Breadcrumb-item>公司动态</Breadcrumb-item>
        </Breadcrumb>

        <!-- 公司动态第一张内容 -->
        <div class="publish_main" style="padding-bottom: 230px;background: url('../../../assets/images/background.png') no-repeat;">
            <p>司马大大获千万级投资，投资方为万达投资</p>

              <div class="box-texts">
                <p style="font-size:26px;">万达千万级投资助力国内领先视频数据管理商司马大大，加持视频时代数据管理生态建设</p>
            </div>

            <p class="con_p">
              <span>中国北京 — 2019年10月 —</span>  业界领先的视频数据解决方案供应商司马大大（北京）智能系统有限公司日前宣布了<span>获得万达投资的千万级A1轮融资</span> ，已完成交割。本轮融资将用于司马大大的市场拓展、人才储备和技术强化，为中国更多的客户提供集海量视频数据存储、视频确权及视频溯源为一体的智能数据解决方案。所有的系统的软硬件都实现了自主可控。
            </p>

            <p class="con_p">
              司马大大是由中国科学院“百人计划”归国科学家马兆远教授创立的一家专注于视频大数据智能管理的高新技术企业。多年以来，司马大大始终专注于图像视觉领域的人工智能科技创新，依托神经感知和深度学习等前沿技术，研发了以<span>Smart Data（智慧数据）</span> 为核心的系列产品，其解决方案能完成在不影响原有视频画质，不改变原有视频帧率、时长的前提下对视频数据进行压缩存储管理，平均<span>节省10倍以上</span> 的存储，以每万路视频<span>存储90天计</span> ，在五年运营期内预计为客户节省近千万元人民币。目前，司马大大的视频数据管理解决方案在安防、公安、交通、医疗、教育等行业的大数据应用场景前沿阵地具有广泛需求。
            </p>

             
            <p class="con_p">
司马大大（北京）智能系统有限公司<span>创始人马兆远教授</span> 表示：“司马大大以强大的技术解决能力获得了大量客户。政府、企业、教育等领域的许多机构客户对我们提供的视频压缩、视频溯源、视频确权等业务给予了高度评价和高度信任。我们将利用这次融资的契机将我们业界领先的技术优势透过日益强大的市场团队带给中国乃至更多的正在寻求视频数据洞察的企业。
            </p>
            <p class="con_p" style="text-indent: 0em">
               司马大大的视频数据管理解决方案包括：
            </p>
         <p class="con_p">
       <p class="pp1"> <span>视频压缩解决方案：</span> 独创BBW视频格式，融合多种AI算法，可以保持高清无损的同时压缩原视频平均10倍以上，使企业原有的视频存储获得10倍扩容，也可使数据对传输带宽占用减少90%。</p>
      <p class="pp1"> <span>传播溯源解决方案</span> ：支持明码、暗码两种格式，绑定客户端IP、MAC地址信息、终端用户信息和其他定制的信息，视频一旦泄露则可以立即追溯到泄密终端，增加泄密者的泄密成本，从源头上防止泄密。</p>
      <p class="pp1"><span> 视频确权解决方案</span> ：为平台方提供视频版权归属信息确权服务，防止视频发生未授权的传播行为，帮助视频内容创作者保护版权、维护合法权益。</p>
            </p>
        </div>
    </div>
</template>

<script>
import header from "../../cuscom/header";
export default {
    beforeRouteEnter: (to, from, next) => {
            next(vm => {
             window.scrollTo(0,0)
            });
        },
}
</script>

<style>
.news-banner {
     width: 100%;
     /* height: 681px; */
 }
 .news-banner img {
     width: 100%;
     height: 100%;
 }


/* 面包屑 */
.nav_rot {
    width: 1200px;
    margin: 0 auto;
    font-size: 18px;
    margin-top: 35px;
}
.ivu-breadcrumb-item-link {
    color: #333333;
}


.publish_main {
    width: 1200px;
    margin: 0 auto;
    color: #333;
    margin-top: 94px;
    overflow: hidden;
    padding-bottom: 60px;
}
.publish_main p:nth-child(1) {
    font-size: 36px;
    /* font-weight: 700; */
    text-align: center;
    margin-bottom: 45px;
}
.publish_main .con_p {
    font-size: 14px;
    text-indent: 2em;
    margin-bottom: 34px;
}
.publish_main h1{
    text-align: center;
    font-size: 30px;
}
.publish_main .traimg{
    display: block;
    margin: 0 auto;
    margin-bottom: 80px;
    margin-top: 80px;
}
.box-texts{
    height: 82px;
    border: 2px dashed #4472C4;
    margin:  0 auto;
    padding: 20px;
    margin-top: 100px;
    margin-bottom: 80px;
}
.pp1{
    margin-left: 25px;
    font-size: 14px;
    
}
.pp1 span{
    font-weight: 600;
}
.con_p span{
    font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/news/invest/invest.vue